
import { formatMoney } from '@shopify/theme-currency'
import React, { useEffect, useRef } from 'react'
import firePriceChange from '../../scripts/dom/priceChangeEvt';

interface MoneyProps {
  amount: number,
  withCurrency?: boolean
}

const Money: React.FunctionComponent<MoneyProps> = ({ amount, withCurrency }: MoneyProps = {amount: null, withCurrency: false}) => {
  const money = (amount : MoneyProps['amount']) => formatMoney(amount, window['theme'][withCurrency ? 'moneyWithCurrencyFormat' : 'moneyFormat'])
  const moneyEl = useRef(null)
  useEffect(() => firePriceChange(moneyEl.current), [amount])
  
  return <span ref={moneyEl}>{money(amount)}</span>
} 

export default Money